/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmessagedeleteddone3Inputs */

const en_groupsmessagedeleteddone3 = /** @type {(inputs: Groupsmessagedeleteddone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The message is gone for everyone.`)
};

const de_groupsmessagedeleteddone3 = /** @type {(inputs: Groupsmessagedeleteddone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Nachricht ist für alle weg.`)
};

/**
* | output |
* | --- |
* | "The message is gone for everyone." |
*
* @param {Groupsmessagedeleteddone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmessagedeleteddone3 = /** @type {((inputs?: Groupsmessagedeleteddone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmessagedeleteddone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmessagedeleteddone3(inputs)
	return de_groupsmessagedeleteddone3(inputs)
});
export { groupsmessagedeleteddone3 as "groupsMessageDeletedDone" }